var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-checkbox-group',{on:{"change":_vm.onChange},model:{value:(_vm.currentValues),callback:function ($$v) {_vm.currentValues=$$v},expression:"currentValues"}},_vm._l((_vm.options),function(item){return _c('a-checkbox',{key:item.id,attrs:{"value":item.value}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }